import { render, staticRenderFns } from "./CampaignsSettings.vue?vue&type=template&id=ed64eb7e&scoped=true&"
import script from "./CampaignsSettings.vue?vue&type=script&lang=js&"
export * from "./CampaignsSettings.vue?vue&type=script&lang=js&"
import style0 from "./CampaignsSettings.vue?vue&type=style&index=0&id=ed64eb7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed64eb7e",
  null
  
)

export default component.exports